import { Box, Paper, Typography, Chip } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { formatCurrency, getCostColor, getCostColorHex } from '../../utils/formatting';

interface TotalCostHeaderProps {
  totalMonthly: number;
  totalDaily: number;
  totalYearly: number;
}

export function TotalCostHeader({ totalMonthly, totalDaily, totalYearly }: TotalCostHeaderProps) {
  const costColor = getCostColor(totalMonthly);
  const costColorHex = getCostColorHex(totalMonthly);

  return (
    <Paper
      elevation={2}
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1100,
        borderRadius: 0,
        borderBottom: '3px solid',
        borderColor: costColorHex,
      }}
    >
      <Box
        sx={{
          maxWidth: 'lg',
          mx: 'auto',
          px: 3,
          py: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 2,
        }}
      >
        {/* Monthly Total */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box>
            <Typography variant="caption" color="text.secondary" display="block">
              Estimated Monthly Cost
            </Typography>
            <Typography
              variant="h4"
              fontWeight={700}
              sx={{ color: costColorHex }}
            >
              {formatCurrency(totalMonthly)}
            </Typography>
          </Box>
          <Chip
            label={costColor === 'success' ? 'Low' : costColor === 'warning' ? 'Medium' : 'High'}
            color={costColor}
            size="small"
            icon={<TrendingUpIcon />}
          />
        </Box>

        {/* Daily and Yearly */}
        <Box sx={{ display: 'flex', gap: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CalendarTodayIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
            <Box>
              <Typography variant="caption" color="text.secondary" display="block">
                Daily Average
              </Typography>
              <Typography variant="h6" fontWeight={600}>
                {formatCurrency(totalDaily)}
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CalendarMonthIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
            <Box>
              <Typography variant="caption" color="text.secondary" display="block">
                Yearly Projection
              </Typography>
              <Typography variant="h6" fontWeight={600}>
                {formatCurrency(totalYearly)}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}
